import {
  getAssignmentRubricUrl,
  getLearningOutcomeUnapprovedUrl,
  getLearningOutcomeUrl,
  getLearningOutcomesUrl,
  getOutcomeForProgramUrl,
  getOutcomeForProgramWithParamsUrl,
  getRatingScaleUrl,
  getUnmappedRatingScaleUrl,
  getUrlForModifyingOutcomeTaxonomyLevel,
  updateLearningOutcomeUrl,
  updateOutcomeDefaultScaleUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class LearningOutcomesService {
  static setTaxonomyLevelToOutcome = (outcomeId, taxonomyLevels) => {
    const params = {};
    params.taxonomyLevels = taxonomyLevels;

    return postRequest(
      getUrlForModifyingOutcomeTaxonomyLevel(outcomeId),
      params
    );
  };

  static getLearningOutcomesByType = (
    learningOutcomeType,
    academicSubject,
    signal = null
  ) => {
    const params = { type: learningOutcomeType };

    if (!!academicSubject && academicSubject.length > 0) {
      params.academicSubject = academicSubject;
    }
    return getRequest(getLearningOutcomesUrl(), params, false, signal);
  };

  static getLearningOutcomeById = (outcomeId, enrichRatings = false) => {
    const params = {};
    if (enrichRatings) {
      params.enrichRatings = enrichRatings;
    }
    return getRequest(getLearningOutcomeUrl(outcomeId), params);
  };

  static createLearningOutcome = (outcome) => {
    return postRequest(getLearningOutcomesUrl(), outcome);
  };

  static getLearningOutcomesByIds = (outcomeIds, enrichRatings = false) => {
    // takes a list of outcome ids as a parameter and returns a list of outcomes
    const params = {};
    if (outcomeIds && outcomeIds.length > 0) {
      params.outcomeIds = outcomeIds;
    }
    if (enrichRatings) {
      params.enriched = enrichRatings;
    }
    return getRequest(getLearningOutcomesUrl() + "/bulk", params);
  };

  static createLearningOutcomeForProgram = (outcome) => {
    return postRequest(getOutcomeForProgramUrl(), outcome);
  };

  static getOutcomesByProgram = (programId) => {
    return getRequest(getOutcomeForProgramWithParamsUrl(programId));
  };

  static updateLearningOutcome = (outcome) => {
    return putRequest(updateLearningOutcomeUrl(outcome.id), outcome);
  };

  static deleteLearningOutcome = (outcome, contextId) => {
    const deleteUrl = outcome.unapproved
      ? getLearningOutcomeUnapprovedUrl(outcome.id, contextId)
      : getLearningOutcomeUrl(outcome.id);

    return deleteRequest(deleteUrl, outcome);
  };

  static getLearningOutcomeTypes = (forExternalAssessment = false) => {
    if (forExternalAssessment) {
      return Promise.resolve().then(() => {
        return [
          { name: "ILO", id: "islo" },
          { name: "PLO", id: "pslo" },

          { name: "CLO", id: "cslo" },
        ];
      });
    } else {
      return Promise.resolve().then(() => {
        return [
          { name: "ILO", id: "islo" },
          { name: "PLO", id: "pslo" },
        ];
      });
    }
  };

  static classifyOutcome = ({
    outcomeId,
    contextId,
    loClass,
    relatedOutcomeId,
    userId,
    categoryId,
    effectiveTermId,
  }) => {
    return putRequest(getLearningOutcomesUrl() + "/" + outcomeId, {
      contextId,
      loClass,
      relatedOutcomeId,
      userId,
      categoryId,
      effectiveTermId,
    });
  };

  static updateOutcomeRatingScaleMap = (data) => {
    const params = {
      rating_scale: data.levels,

      rating_to_mastery_level_map_id: data.map_id,
    };

    if (data.mastery_at) {
      params.mastery_at = data.mastery_at;
    }
    if (data.rating_scale_id) {
      params.rating_scale_id = data.rating_scale_id;
    }
    return putRequest(getRatingScaleUrl(data.id), params);
  };

  static upsertAssignmentRubric = (data) => {
    return postRequest(getAssignmentRubricUrl(), data);
  };

  static getOutcomesWithUnmappedRatingScales = () => {
    return getRequest(getUnmappedRatingScaleUrl());
  };

  static updateRatingScaleDefault = (outcomeId, ratingScaleId) => {
    const params = { rating_scale_id: ratingScaleId };
    return putRequest(updateOutcomeDefaultScaleUrl(outcomeId), params);
  };
}
